import React from 'react';
import * as yup from 'yup';
import { withFormik } from 'formik';
import { isNil } from 'lodash';
import styled from 'styled-components';
import { toast } from 'react-toastify';
import swal from 'sweetalert';
import {
  // Label,
  Title,
  Tab,
} from 'rbx';
import uuidv4 from 'uuid/v4';

import { Tabs, Radio } from '../../../components/elements';
import Layout from '../../../components/global/Layout';
import Input from '../../../components/elements/Input';
import Select from '../../../components/elements/Select';
import Header from './Header';
import Footer from './Footer';

import {
  createNotificationCampaign,
  handleFileUpload,
  updateNotificationCampaign,
} from './helpers';

const Container = styled.div`
  width: 80%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  padding: 2rem;
`;

const notificationPlatfromValues = [{ value: 'SendGrid', label: 'SendGrid' }];

const Form = props => {
  const [activeTab, setActiveTab] = React.useState('tab1');
  const {
    values,
    errors,
    setFieldValue,
    history,
    isSubmitting,
    handleSubmit,
    isUpdate,
    canUpdate,
  } = props;
  console.log(values);
  return (
    <Layout>
      <Header
        showSubmit={isUpdate ? canUpdate : true}
        history={history}
        loading={isSubmitting}
        handleSubmit={() => {
          if (!isUpdate && values.uploaded_file === '') {
            toast.error('Please upload a csv file!');
          } else if (errors.reply_to) {
            toast.error(errors.reply_to);
          } else {
            handleSubmit();
          }
        }}
      />
      <Tabs className="tabs is-medium is-fullwidth">
        <Tab
          onClick={() => {
            setActiveTab('tab1');
          }}
          active={activeTab === 'tab1'}
          style={{ cursor: activeTab === 'tab1' ? 'text' : 'pointer' }}
        >
          Notification Details
        </Tab>
      </Tabs>
      {activeTab === 'tab1' && (
        <>
          <Container>
            <div>
              <Input
                label="Notification Title"
                name="title"
                id="EmailCampaign__notification_title"
                value={values.title}
                onChange={e => setFieldValue('title', e.target.value)}
                // optionalText="(Min 3 Characters and Max 50 Characters)"
                errors={errors.name}
                required
              />
              <div style={{ marginTop: '-8px' }}>
                <span style={{ fontSize: '10px', color: 'black' }}>
                  Min 3 Characters and Max 50 Characters
                </span>
              </div>
            </div>
            <Select
              label="Status"
              disabled
              value={[{ value: values.status, label: values.status }]}
            />
            <Input
              label="Template ID"
              name="template_id"
              id="EmailCampaign__templateId"
              value={values.template_id}
              onChange={e => setFieldValue('template_id', e.target.value)}
              errors={errors.template_id}
              required
            />
            <Select
              label="Platform"
              options={notificationPlatfromValues}
              id="EmailCampaign__notificationPlatfrom"
              value={[values.platform]}
              onChange={value => setFieldValue('notification_platform', value)}
              errors={errors.platform}
              required
            />
            <div>
              <Input
                label="Copy to Email IDs"
                name="copy_emails"
                id="EmailCampaign__copy_emails"
                value={values.copy_emails}
                onChange={e => setFieldValue('copy_emails', e.target.value)}
                errors={errors.copy_emails}
              />
              <div
                style={{
                  marginTop: '-8px',
                }}
              >
                <span
                  style={{
                    marginTop: '-8px',
                    fontSize: '10px',
                    color: 'black',
                  }}
                >
                  Enter Email IDs separated by ; and no space in between
                </span>
              </div>
            </div>

            <Input
              label="Reply to Email IDs"
              name="reply_to"
              id="EmailCampaign__reply_to"
              value={values.reply_to}
              onChange={e => setFieldValue('reply_to', e.target.value)}
              errors={errors.reply_to}
            />
            <div className="is-flex is-justify-content-space-between">
              <Title className="label">Mailing List Source:</Title>
              <div>
                <Radio
                  label="KRAVEiN Platform"
                  value={values.source === 'Kravein'}
                  disabled
                />
              </div>
              <div>
                <Radio
                  label="CSV Upload"
                  value={values.source === 'CSV'}
                  disabled
                />
              </div>
            </div>
            <div />
            {values.source === 'CSV' && !isUpdate && (
              <div>
                <p className="is-size-3">
                  Upload File To S3 <span className="has-text-danger">*</span>
                </p>
                <div
                  style={{
                    margin: '0.5rem',
                  }}
                >
                  <input
                    type="file"
                    id="upload_csv_to_s3"
                    onChange={event => {
                      setFieldValue('uploaded_file', event.target.files[0]);
                    }}
                  />
                </div>
              </div>
            )}
            {values.source === 'CSV' && isUpdate && (
              <div>
                <p className="is-size-3">CSV successfully submitted!</p>
                <a href={props.csvUrl} target="__blank">
                  {props.csvUrl}
                </a>
              </div>
            )}
          </Container>
        </>
      )}
      <Footer
        history={history}
        loading={isSubmitting}
        handleSubmit={() => {
          if (!isUpdate && values.uploaded_file === '') {
            toast.error('Please upload a csv file!');
          } else if (errors.reply_to) {
            toast.error(errors.reply_to);
          } else {
            handleSubmit();
          }
        }}
        showSubmit={isUpdate ? canUpdate : true}
      />
    </Layout>
  );
};

const EmailCampaignForm = withFormik({
  mapPropsToValues: ({
    userId,
    templateId,
    title,
    platform,
    copyEmails,
    replyTo,
    notificationCampaignId,
    status,
  }) => ({
    notification_campaign_id: !isNil(notificationCampaignId)
      ? notificationCampaignId
      : uuidv4(),
    user_id: userId,
    template_id: !isNil(templateId) ? templateId : '',
    title: !isNil(title) ? title : '',
    platform: !isNil(platform)
      ? { value: platform, label: platform }
      : { value: 'SendGrid', label: 'SendGrid' },
    copy_emails: !isNil(copyEmails) ? copyEmails.join(';') : '',
    reply_to: !isNil(replyTo) ? replyTo : '',
    status: !isNil(status) ? status : 'PENDING',
    source: 'CSV',
    uploaded_file: '',
  }),

  validate: values => {
    console.log(values);
    const errors = {};

    return errors;
  },

  validationSchema: yup.object().shape({
    reply_to: yup.string().email('Please provide valid reply to email'),
  }),

  handleSubmit: async (values, { props }) => {
    const titleValidationSchema = yup.object({
      value: yup
        .string()
        .min(3, 'Title should be at least 3 characters long')
        .max(50, 'Title should be less than 50 characters')
        .required('Title is required!'),
    });
    const data1 = { value: values.title };

    try {
      titleValidationSchema.validateSync(data1, { abortEarly: false });
    } catch (error) {
      toast.error(error.errors[0]);
      return;
    }

    const templateIdValidationSchema = yup.object({
      value: yup.string().required('Template Id is required!'),
    });
    const data2 = { value: values.template_id };

    try {
      templateIdValidationSchema.validateSync(data2, {
        abortEarly: false,
      });
    } catch (error) {
      toast.error(error.errors[0]);
      return;
    }

    const {
      notification_campaign_id,
      user_id,
      template_id,
      platform,
      copy_emails,
      reply_to,
      status,
      csv_url,
      csv_key,
      title,
      source,
    } = values;

    const input = {
      notification_campaign_id,
      user_id,
      template_id,
      platform: platform.value,
      copy_emails: copy_emails.split(';').filter(ele => ele),
      reply_to,
      status,
      csv_url,
      csv_key,
      title,
      source,
    };

    if (values.uploaded_file) {
      const fileUploadRes = await handleFileUpload({
        file: values.uploaded_file,
        userId: user_id,
        templateId: template_id,
      });

      if (fileUploadRes.error) {
        toast.error('Error uploading file!');
        return;
      }

      input.csv_url = fileUploadRes.data.csv_url;
      input.csv_key = fileUploadRes.data.csv_key;
    } else if (props.csvUrl && props.csvkey) {
      input.csv_url = props.csvUrl;
      input.csv_key = props.csvkey;
    }

    if (props.isUpdate) {
      const res = await updateNotificationCampaign({
        input,
      });

      if (res) {
        toast.error(res);
      } else {
        swal(
          'Great!',
          'You have successfully updated the email campaign template',
          'success',
        ).then(() => props.history.goBack());
      }
    } else {
      const res = await createNotificationCampaign({
        input,
      });
      if (res) {
        toast.error(res);
      } else {
        swal(
          'Great!',
          'You have successfully created the email campaign template',
          'success',
        ).then(() => props.history.goBack());
      }
    }
  },
  displayName: 'EmailCampaignForm',
})(Form);

export default EmailCampaignForm;
